import { useEffect, useRef } from 'react'
import { CouponType } from './couponType'
import { CouponDescription } from './couponDescription'
import { ButtonNextForm } from './buttonNextForm'
import { useModalForms } from '../../../modalForms/modalFormsContext'
import { TypeAndDescriptionProvider } from './typeAndDescriptionContext'

import { Container } from './style'


export function TypeAndDescription () {
    const { changeVisibleContent, alertButtonToClickHim } = useModalForms()

    const bottomRef = useRef(null)

    useEffect(() => {
        if(alertButtonToClickHim.breathButton){
            bottomRef.current.scrollIntoView({
                behavior: 'smooth'
            })
        }
    }, [alertButtonToClickHim])

    return(
        <Container changeVisibleContent={changeVisibleContent}>

            <TypeAndDescriptionProvider>

                <CouponDescription />
                
                <CouponType />

                <ButtonNextForm />
                
            </TypeAndDescriptionProvider>

            <div ref={bottomRef} />
        </Container>
    )
}